import { Spin } from 'antd';

/** Shown while the boot `/auth/me` check is in flight — before we know
 * whether to render the app shell or bounce to /login. */
export function FullPageSpinner() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
      }}
    >
      <Spin size="large" />
    </div>
  );
}
